import { render, staticRenderFns } from "./blog-post.vue?vue&type=template&id=443b2951"
import script from "./blog-post.vue?vue&type=script&lang=js"
export * from "./blog-post.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports